//Module Keys
let locales = {};

//Merge Views
import mainView from '../../views/main/lan/en';
locales = { ...locales, ...mainView };

import vehicleDetailView from '../../views/vehicleDetail/lan/en';
locales = { ...locales, ...vehicleDetailView };

import entityDetails from '../../modals/entityDetails/lan/en';
locales = { ...locales, ...entityDetails };

import manageServiceItems from '../../modals/manageServiceTasks/lan/en';
locales = { ...locales, ...manageServiceItems };

import deleteMaintenanceService from '../../modals/deleteMaintenanceService/lan/en';
locales = { ...locales, ...deleteMaintenanceService };

import scheduleDriverTask from '../../modals/scheduleDriverTask/lan/en';
locales = { ...locales, ...scheduleDriverTask };

import createEditDriverTask from '../../modals/createEditDriverTask/lan/en';
locales = { ...locales, ...createEditDriverTask };

import createEditMaintenanceService from '../../modals/createEditMaintenanceService/lan/en';
locales = { ...locales, ...createEditMaintenanceService };

import driversTab from '../../views/main/components/driversTab/lan/en';
locales = { ...locales, ...driversTab };

import vehiclesTab from '../../views/main/components/vehiclesTab/lan/en';
locales = { ...locales, ...vehiclesTab };

import deleteDriverScheduledTask from '../../modals/deleteDriverScheduledTask/lan/en';
locales = { ...locales, ...deleteDriverScheduledTask };

import completeDriverScheduledTask from '../../modals/completeDriverScheduledTask/lan/en';
locales = { ...locales, ...completeDriverScheduledTask };

import serviceDetail from '../../views/serviceDetail/lan/en';
locales = { ...locales, ...serviceDetail };

import exportVehicles from '../../views/main/components/vehiclesTab/exportVehicles/lan/en';
locales = { ...locales, ...exportVehicles };

import deleteMaintenanceServiceUnit from '../../modals/deleteMaintenanceServiceUnit/lan/en';
locales = { ...locales, ...deleteMaintenanceServiceUnit };

import scheduleMaintenanceService from '../../modals/scheduleMaintenanceService/lan/en';
locales = { ...locales, ...scheduleMaintenanceService };

import completeMaintenanceService from '../../modals/completeMaintenanceService/lan/en';
locales = { ...locales, ...completeMaintenanceService };

import manageDriverTasksScheduled from '../../modals/manageDriverTasksScheduled/lan/en';
locales = { ...locales, ...manageDriverTasksScheduled };

import maintenanceServicesToComplete from '../../modals/maintenanceServicesToComplete/lan/en';
locales = { ...locales, ...maintenanceServicesToComplete };

import emissionCheckTab from '../../views/main/components/emissionCheckTab/lan/en';
locales = { ...locales, ...emissionCheckTab };

locales = {
  ...locales,
  "maintenance_VINNumberValidation": "The VIN number must contain 17 characters"
}

export default locales;
